var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewPremiumMembers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "99px",
    height: "104px",
    viewBox: "0 0 99 104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3.-Upgrade-&-Payment-\\uD83D\\uDCB3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Upgrade-8",
    transform: "translate(-146.000000, -91.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Upgrade/Unlock-Premium-Sugar-Daddy",
    transform: "translate(119.000000, 69.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    strokeWidth: 1,
    fillRule: "evenodd",
    transform: "translate(30.933333, 25.133333)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#CCCCCC",
    strokeWidth: 6,
    fillRule: "nonzero",
    x: 0,
    y: 37.7,
    width: 62.8333333,
    height: 58,
    rx: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.9833333,
    y1: 29.4833333,
    x2: 83.1333333,
    y2: 31.9,
    id: "Line-18",
    stroke: "#CCCCCC",
    strokeWidth: 6,
    strokeLinecap: "round",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.5333333,
    y1: 19.3333333,
    x2: 87.9666667,
    y2: 11.6,
    id: "Line-19",
    stroke: "#CCCCCC",
    strokeWidth: 6,
    strokeLinecap: "round",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 64.7666667,
    y1: 11.6,
    x2: 69.6,
    y2: 1.93333333,
    id: "Line-20",
    stroke: "#CCCCCC",
    strokeWidth: 6,
    strokeLinecap: "round",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5666667,37.4534696 L12.5666667,15.5156318 C13.1701413,5.38903672 19.1593283,0.219265565 30.5342277,0.006318348 C41.9091271,-0.206628869 48.2205164,4.96314228 49.4683957,15.5156318 L49.4683957,23.9967002",
    id: "Path-11",
    stroke: "#CCCCCC",
    strokeWidth: 6,
    strokeLinecap: "round",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#CCCCCC",
    fillRule: "nonzero",
    cx: 31.4166667,
    cy: 61.3833333,
    r: 7.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    fillRule: "nonzero",
    x: 28.0333333,
    y: 63.8,
    width: 6.76666667,
    height: 16.4333333,
    rx: 3.38333333
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-Copy-2",
    fill: "#710D0D",
    fillRule: "nonzero",
    points: "101.016667 117.649377 85.9595678 125.607652 88.8754374 108.828258 76.6537689 96.967348 93.5129743 94.5553869 101.016667 79.2666667 108.520359 94.5553869 125.379564 96.967348 113.157896 108.828258 116.073766 125.607652"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewPremiumMembers);
export default __webpack_public_path__ + "static/media/view_premium_members.fe19e3d4b0748a90a95082046f97f5cb.svg";
export { ForwardRef as ReactComponent };